import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-dd64db22")

_pushScopeId("data-v-dd64db22")
const _hoisted_1 = { class: "management-frame" }
const _hoisted_2 = { class: "frame-title flex justify-between" }
const _hoisted_3 = { class: "frame-title-items flex" }
const _hoisted_4 = { class: "frame-title-controllers flex" }
const _hoisted_5 = { class: "frame-content" }
const _hoisted_6 = { class: "frame-page" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "title", {}, () => [
        _createVNode("div", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.managementFrameTitle.titleList.value, (item, index) => {
            return (_openBlock(), _createBlock("div", {
              class: ["f-t-item", {'actived-item': index === _ctx.managementFrameTitle.currentIndex.value}],
              key: index,
              onClick: ($event: any) => (_ctx.managementFrameTitle.handleClick(index))
            }, _toDisplayString(item.name), 11, ["onClick"]))
          }), 128))
        ])
      ]),
      _createVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "controllers")
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "content")
    ]),
    _createVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "pagination")
    ])
  ]))
})